<script setup lang="ts">
  import { useForwardProps } from 'radix-vue';
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import type { PropertyListVariants } from '.';
  import { propertyListVariants } from '.';

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class'];
      orientation?: PropertyListVariants['orientation'];
      size?: PropertyListVariants['size'];
      width?: PropertyListVariants['width'];
    }>(),
    {
      orientation: 'vertical',
      size: 'default',
      width: 'default',
    },
  );

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <div
    v-bind="forwardedProps"
    :class="cn('flex min-w-fit', propertyListVariants({ orientation, size, width }), props.class)"
  >
    <slot />
  </div>
</template>
